(function () {
  'use strict';


  angular
    .module('activeInactiveCrewList')
    .directive('focusOn',function($timeout) {
      return {
        restrict : 'A',
        link : function(vm,$element,$attr) {
          vm.$watch($attr.focusOn,function(_focusVal) {
            $timeout(function() {
              _focusVal ? $element[0].focus() : $element[0].blur();
            });
          });
        }
      }
    })
    .controller('ActiveInactiveCrewListCtrl', ActiveInactiveCrewListCtrl);

  function ActiveInactiveCrewListCtrl(CommonFuelService,CommonMasterData,applicationConstants,MessageService,crewScheduleService,RemoteService,$sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'ActiveInactiveCrewListCtrl';

    vm.model = {
      searchPanelToggle:true,
      searchCriteria:{
        fromDate: null,
        toDate: null,
        crewType :null,
        status :null,
        base:null,
        aircraftType:null
      },
      masterList: {
        crewTypeList:[],
        statusList:[],
        baseList:[],
        aircraftTypes:[],

      },
      initialSearchDone:false,
      reportUrl:'',
      reportServerBaseUrl :null
    };

    vm.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    }


    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
      vm.model.initialSearchDone=false;
    };

    vm.submitSearch = function (params){
      search(params);
    };


    function search(params){
      vm.model.initialSearchDone=true;
      vm.model.searchPanelToggle = false;
      var url = CommonLogicService.getReportUrl('crew_report.rptdesign',getSearchParamMap(params));
      vm.model.reportUrl = $sce.trustAsResourceUrl(url);

      //  vm.model.reportUrl ='http://localhost:8090/service.aerolinecrew.report/frameset?__report=report/crew_report.rptdesign&crew_type='+crewType+'&crew_base='+base+'&status='+status;
      //MessageService.error('No Data found');
    }



    function getSearchParamMap(params){
      var searchParamMap = {};
      searchParamMap["fromDate"] = params.fromDate;
      searchParamMap["toDate"] = params.toDate;
      searchParamMap["crew_base"] = params.base === null || params.base === undefined || params.base.airPortCode === null ? 'ALL' : params.base.airPortCode;
      searchParamMap["crew_type"] = params.crewType === null || params.crewType === undefined || params.crewType.crewTypeCode === null ? 'ALL' : params.crewType.crewTypeCode;
      searchParamMap["status"]= params.status === null || params.status === undefined || params.status.value === null ? 'ALL' : params.status.value;
      searchParamMap["airCraft_type"] = params.aircraftType === null || params.aircraftType === undefined || params.aircraftType.airCraftType === null ? 'ALL' : params.aircraftType.airCraftType;
      searchParamMap["referrer"] = window.location.origin;
      return searchParamMap;
    }



    CommonMasterData.getCrewTypeList(function(crewTypeList){
      var initialCrew = {crewTypeCode: null, crewTypeDescription: "All", crewTypeMasterCode: null, crewTypeMasterCodeDesc: null, rank: 0};
      vm.model.masterList.crewTypeList = crewTypeList;
      vm.model.masterList.crewTypeList.splice(0, 0, initialCrew);
      vm.model.searchCriteria.crewType = initialCrew;
    },function () {});

    CommonMasterData.getCrewBaseList(function(baseList) {
      var initialBase = {airPortCode: null, airPortCodeDecs: "All "};
      vm.model.masterList.baseList = baseList;
      vm.model.masterList.baseList.splice(0, 0, initialBase);
      vm.model.searchCriteria.base = initialBase;
      vm.model.masterList.statusList = CommonFuelService.getStatusList();
      vm.model.searchCriteria.status = CommonFuelService.getDefaultStatus();
    }, function() {
      console.log('Crew Base List retrieval error');
    });

    // aircraft types
    CommonMasterData.getAircraftModels(function (aircraftTypes) {
      var initialAirCraft = {airCraftTypeCode: null, airCraftType: "ALL"};
      vm.model.masterList.aircraftTypes = aircraftTypes;
      vm.model.masterList.aircraftTypes.splice(0, 0, initialAirCraft);
      vm.model.searchCriteria.aircraftType = initialAirCraft;
    }, function () {
      console.log('Aircraft type retrieval error');
    });

  }
}());
